import React, { useEffect, useContext, useState } from 'react';
import './Boost.css'; // Import CSS file for styling
import { LanguageContext } from '../../LanguageContext'; // Adjust the import path as needed

function Boost() {
  const { language } = useContext(LanguageContext);
  const [animationIndex, setAnimationIndex] = useState(0);

  const dataTextEn = [
    "BOOST YOUR CREDIT!", 
    "STOP GETTING DENIED.", 
    "HERE'S HOW:"
  ];

  const dataTextEs = [
    "¡AUMENTA TU CRÉDITO!", 
    "DEJA DE SER NEGADO.", 
    "ASÍ ES CÓMO:"
  ];

  const dataText = language === 'es' ? dataTextEs : dataTextEn;

  useEffect(() => {
    function typeWriter(text, i, fnCallback) {
      if (i < text.length) {
        const boostTextElement = document.querySelector("#boost-text");
        if (boostTextElement) {
          boostTextElement.textContent = text.substring(0, i + 1);
        }
        setTimeout(function() {
          typeWriter(text, i + 1, fnCallback);
        }, 65);
      } else if (typeof fnCallback === 'function') {
        setTimeout(fnCallback, 700);
      }
    }

    function startTextAnimation(i) {
      if (i >= dataText.length) {
        setTimeout(function() {
          setAnimationIndex(0);
        }, 3000);
        return;
      }

      if (dataText[i] && dataText[i].length > 0) {
        typeWriter(dataText[i], 0, function() {
          startTextAnimation(i + 1);
        });
      }
    }

    startTextAnimation(animationIndex);
  }, [language, animationIndex, dataText]);

  return (
    <div className="boost-container">
      <h1 className="head" id="boost-text"></h1>
      <br />
      <div className="separator"></div>
      <br />
      <span className='large-text'>
        {language === 'es' ? "Tradeline Queens agrega legalmente historial positivo a tu informe de crédito." : "Tradeline Queens legally adds positive history to your credit report."}
      </span>
      <span className="large-text">
        {language === 'es' ? "Hacemos esto agregándote como usuario autorizado a una línea de crédito sazonada, permitiéndote “aprovechar” la cuenta en buen estado." : "We do this by adding you as an authorized user to a seasoned tradeline, allowing you to “piggyback” off of the account in good standing."}
      </span>
      <span className="large-text">
        {language === 'es' ? "Esto es posible porque los acreedores proporcionarán a las agencias de crédito el historial completo de cualquier línea de crédito para un usuario autorizado." : "This is possible because creditors will provide credit bureaus the entire account history on any given tradeline for an authorized user."}
      </span>
      <span className="large-text">
        {language === 'es' ? "FICO® digiere este crédito recién agregado y recalcula tu puntaje con mejoras drásticas." : "FICO® digests this newly added credit and recalculates your score with drastic improvements."}
      </span>
      <br />
      <br />
      <br />
    </div>
  );
}

export default Boost;


// import React, { useEffect } from 'react';
// import './Boost.css'; // Import CSS file for styling
// import TranslateText from '../../translation/TranslateText'; // Adjust the import path as needed

// function Boost() {
//   useEffect(() => {
//     var dataText = [
//       "BOOST YOUR CREDIT!", 
//       "¡AUMENTA TU CRÉDITO!",
//       "STOP GETTING DENIED.", 
//       "DEJA DE SER NEGADO.",
//       "HERE'S HOW:",
//       "ASÍ ES CÓMO:"
//     ];

//     function typeWriter(text, i, fnCallback) {
//       if (i < text.length) {
//         const boostTextElement = document.querySelector("#boost-text");
//         if (boostTextElement) {
//           boostTextElement.textContent = text.substring(0, i + 1);
//         }
//         setTimeout(function() {
//           typeWriter(text, i + 1, fnCallback)
//         }, 65);
//       } else if (typeof fnCallback === 'function') {
//         setTimeout(fnCallback, 700);
//       }
//     }
    
//     function startTextAnimation(i) {
//       if (i >= dataText.length) {
//         setTimeout(function() {
//           startTextAnimation(0);
//         }, 3000);
//         return;
//       }
      
//       if (dataText[i] && dataText[i].length > 0) {
//         typeWriter(dataText[i], 0, function() {
//           startTextAnimation(i + 1);
//         });
//       }
//     }

//     startTextAnimation(0);
//   }, []);

//   return (
//     <div className="boost-container">
//       <h1 className="head" id="boost-text">BOOST YOUR CREDIT</h1>
//       <br />
//       <div className="separator"></div>
//       <br />
//       <span className='bold large-text'>
//         <TranslateText text="Tradeline Queens legally adds positive history to your credit report." />
//       </span>
//       <span className="large-text">
//         <TranslateText text="We do this by adding you as an authorized user to a seasoned tradeline, allowing you to “piggyback” off of the account in good standing." />
//       </span>
//       <span className="large-text">
//         <TranslateText text="This is possible because creditors will provide credit bureaus the entire account history on any given tradeline for an authorized user." />
//       </span>
//       <span className="large-text">
//         <TranslateText text="FICO® digests this newly added credit and recalculates your score with drastic improvements." />
//       </span>
//       <br />
//       <br />
//       <br />
//     </div>
//   );
// }

// export default Boost;








// import React, { useEffect } from 'react';
// import './Boost.css'; // Import CSS file for styling

// function Boost() {
//   useEffect(() => {
//     var dataText = [
//       "BOOST YOUR CREDIT!", 
//       "STOP GETTING DENIED.", 
//       "HERE'S HOW:"
//     ];

//     function typeWriter(text, i, fnCallback) {
//       if (i < text.length) {
//         const boostTextElement = document.querySelector("#boost-text");
//         if (boostTextElement) {
//           boostTextElement.textContent = text.substring(0, i + 1);
//         }
//         setTimeout(function() {
//           typeWriter(text, i + 1, fnCallback)
//         }, 65);
//       } else if (typeof fnCallback === 'function') {
//         setTimeout(fnCallback, 700);
//       }
//     }
    
//     function startTextAnimation(i) {
//       if (i >= dataText.length) {
//         setTimeout(function() {
//           startTextAnimation(0);
//         }, 3000);
//         return;
//       }
      
//       if (dataText[i] && dataText[i].length > 0) {
//         typeWriter(dataText[i], 0, function() {
//           startTextAnimation(i + 1);
//         });
//       }
//     }

//     startTextAnimation(0);
//   }, []);

//   return (
//     <div className="boost-container">
//       <h1 className="head" id="boost-text">BOOST YOUR CREDIT</h1>
//       <br></br>
//       <div className="separator"></div>
//       <br></br>
//       <span className='bold large-text'>Tradeline Queens legally adds positive history to your credit report.</span>
//       <span className="large-text">We do this by adding you as an authorized user to a seasoned tradeline, allowing you to “piggyback” off of the account in good standing.</span>
//       <span className="large-text">This is possible because creditors will provide credit bureaus the entire account history on any given tradeline for an authorized user.</span>
//       <span className="large-text"> FICO® digests this newly added credit and recalculates your score with drastic improvements. </span>
//       <br></br>
//       <br></br>
//       <br></br>
//     </div>
//   );
// }

// export default Boost;

// import React, { useEffect } from 'react';
// import './Boost.css'; // Import CSS file for styling

// function Boost() {
//   useEffect(() => {
//     var dataText = [
//       "BOOST YOUR CREDIT!", 
//       "STOP GETTING DENIED.", 
//       "HERE'S HOW:"
//     ];

//     function typeWriter(text, i, fnCallback) {
//       if (i < text.length) {
//         document.querySelector("#boost-text").textContent = text.substring(0, i + 1);
//         setTimeout(function() {
//           typeWriter(text, i + 1, fnCallback)
//         }, 65);
//       } else if (typeof fnCallback === 'function') {
//         setTimeout(fnCallback, 700);
//       }
//     }
    
//     function startTextAnimation(i) {
//       if (i >= dataText.length) {
//         setTimeout(function() {
//           startTextAnimation(0);
//         }, 3000);
//         return;
//       }
      
//       if (dataText[i] && dataText[i].length > 0) {
//         typeWriter(dataText[i], 0, function() {
//           startTextAnimation(i + 1);
//         });
//       }
//     }

//     startTextAnimation(0);
//   }, []);

//   return (
//     <div className="boost-container">
//       <h1 className="head" id="boost-text">BOOST YOUR CREDIT</h1>
//       <br></br>
//       <div className="separator"></div>
//       <br></br>
//       <span className='bold large-text'>Tradeline Queens legally adds positive history to your credit report.</span>
//       <span className="large-text">We do this by adding you as an authorized user to a seasoned tradeline, allowing you to “piggyback” off of the account in good standing.</span>
//       <span className="large-text">This is possible because creditors will provide credit bureaus the entire account history on any given tradeline for an authorized user.</span>
//       <span className="large-text"> FICO® digests this newly added credit and recalculates your score with drastic improvements. </span>
//       <br></br>
//       <br></br>
//       <br></br>
//     </div>
//   );
// }

// export default Boost;


// import './Boost.css'; // Import CSS file for styling

// import React, { useEffect } from 'react';

// function Boost() {
//   useEffect(() => {
//     var dataText = [
//       "BOOST YOUR CREDIT!", 
//       "STOP GETTING DENIED.", 
//       "HERE'S HOW:"
//     ];

//     function typeWriter(text, i, fnCallback) {
//         if (i < text.length) {
//           // Append the next character to the text content
//           document.querySelector("#boost-text").textContent = text.substring(0, i + 1);
      
//           // Wait for a short delay before typing the next character
//           setTimeout(function() {
//             typeWriter(text, i + 1, fnCallback)
//           }, 65); // Adjust the timeout duration as needed
//         } else if (typeof fnCallback === 'function') {
//           // If there is a callback function, call it after typing is complete
//           setTimeout(fnCallback, 700);
//         }
//       }
      

//     function StartTextAnimation(i) {
//       if (i >= dataText.length) {
//         // If index exceeds array length, reset to 0 after a timeout
//         setTimeout(function() {
//           StartTextAnimation(0);
//         }, 3000);
//         return; // Exit the function to prevent further execution
//       }
      
//       // Check if dataText[i] exists and has a length property
//       if (dataText[i] && dataText[i].length > 0) {
//         // Start typewriter animation for the text at index i
//         typeWriter(dataText[i], 0, function() {
//           // After animation, recursively call StartTextAnimation for the next index
//           StartTextAnimation(i + 1);
//         }, 3000);
//       }
//     }

//     // Start the text animation when the component mounts
//     StartTextAnimation(0);
//   }, []); // Empty dependency array ensures the effect runs only once

//   return (
//     <div className="boost-container">
//       <h1 className="head" id="boost-text">BOOST YOUR CREDIT</h1>
//       <br></br>
//       <div className="separator"></div>
//       <br></br>
//       <span className='bold large-text'>Tradeline Queens legally adds positive history to your credit report.</span>
//       <span className="large-text">We do this by adding you as an authorized user to a seasoned tradeline, allowing you to “piggyback” off of the account in good standing.</span>
//       <span className="large-text">This is possible because creditors will provide credit bureaus the entire account history on any given tradeline for an authorized user.</span>
//       <span className="large-text"> FICO® digests this newly added credit and recalculates your score with drastic improvements. </span>
//       <br></br>
//       <br></br>
//       <br></br>
//     </div>
//   );
// }

// export default Boost;
